import { Axis as VisxAxis } from '@visx/axis';
import BaseAxis from "./BaseAxis.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Axis(props) {
  return /*#__PURE__*/_jsx(BaseAxis, {
    AxisComponent: VisxAxis,
    ...props
  });
}